




import { Component, Vue } from "vue-property-decorator";

@Component({
  data() {
    return {
      siteKey: "6LcGSMUUAAAAAB9DOlxVpEzD-iJ4vrsMl66iH-Di",
      widgetId: 0
    };
  },
  methods: {
    execute() {
      window.grecaptcha.execute(this.$data.widgetId);
    },
    reset() {
      window.grecaptcha.reset(this.$data.widgetId);
    },
    render() {
      if (window.grecaptcha) {
        this.$data.widgetId = window.grecaptcha.render("g-recaptcha", {
          sitekey: this.$data.siteKey,
          callback: (response: any) => {
            console.log(window.grecaptcha.getResponse);
            this.$emit("verify", response);
            // @ts-ignore
            this.reset();
          }
        });
      }
    }
  },
  mounted() {
    // @ts-ignore
    this.render();
  }
})
export default class GReCaptcha extends Vue {}
